import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-values-typeof',
  slug: 'typeof',
  title: 'What does typeof say?',
  type: 'predict',
  estSeconds: 45,
  contentVersion: 1,
  isGuest: true,
});
